exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settings-panel[data-v-ac0ccb4c] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 5px;\n}\n.settings-label[data-v-ac0ccb4c] {\n  color: #999;\n  margin: 0;\n}\n", ""]);

